import { Button, Group, Paper, Stack, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useEffect } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router';
import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import PageLoader from 'src/UI/loader/PageLoader';
import { useAppContainerContext } from 'src/UI/app-container/AppContainerContext';
import { GenericErrorPage } from 'src/error/GenericErrorPage';
import { useFlags } from 'src/feature-flags/FlagsHook';
import MatchingSectionNav from './components/MatchingSectionNav';
import useProviderMatches from './hooks/useProviderMatches';

export default function MatchingWorkspacePage() {
  const { setSidebarCollapsed } = useAppContainerContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const provider = searchParams.get('provider');

  const { flagEnabledBulkValControlCentre } = useFlags();
  const { isSystemAdmin } = useCurrentUser();

  useEffect(() => {
    setSidebarCollapsed(true);
    return () => setSidebarCollapsed(false);
  }, [setSidebarCollapsed]);

  const { data: suggestions, isLoading, isError } = useProviderMatches(provider);

  if (!flagEnabledBulkValControlCentre || !isSystemAdmin) {
    return <Navigate to="/company/funds" replace />;
  }

  if (!provider) {
    return <Navigate to="/company/connected-assets" replace />;
  }

  if (isLoading) return <PageLoader />;
  if (isError) return <GenericErrorPage error="Failed to load matching suggestions." />;

  return (
    <Paper variant="content" p="xxl">
      <Stack gap="lg">
        <Group>
          <Button
            variant="subtle"
            size="compact-sm"
            leftSection={<IconArrowLeft size={14} />}
            onClick={() => navigate('/company/connected-assets')}
          >
            Connected Assets
          </Button>
        </Group>
        <Text size="displayMd" fw={FONT_WEIGHTS.medium} c="gray.10">
          {provider}
        </Text>
        <MatchingSectionNav suggestions={suggestions ?? []} />
      </Stack>
    </Paper>
  );
}
